<script>
  import PurchaseTab from '@/components/cashier/PurchaseTab.vue';
  import WithdrawTab from '@/components/cashier/WithdrawTab.vue';

  export default {
    name: 'CashierPopup',

    components: {
      PurchaseTab,
      WithdrawTab,
    },

    data: () => ({
      showDialog: false,
      activeTab: '',
      activePaymentMethod: '',
      activeComponent: '',
    }),

    computed: {
      contentClass() {
        return `cashier-popup cashier-popup--${this.activeTab} cashier-popup--${this.activePaymentMethod}`;
      },

      tabs: () => [
        {
          value: 'purchase',
          text: 'Deposit',
          component: 'PurchaseTab',
        },
        {
          value: 'withdrawal',
          text: 'Withdraw',
          component: 'WithdrawTab',
        },
      ],

      popupData() {
        return this.$store.state.walletDialog;
      },
    },

    created() {
      this.$store.dispatch('getCurrencies');
    },

    watch: {
      popupData: {
        immediate: true,
        handler(newValue) {
          this.activeTab = newValue.tab || this.tabs[0].value;
          this.activeComponent = this.tabs.find((tab) => tab.value === this.activeTab)?.component;
          this.showDialog = newValue.value || false;
        },
      },
    },

    methods: {
      closeDialog() {
        this.$store.dispatch('closeCashierDialog');
      },

      onTabClick(tab) {
        this.activeTab = tab.value;
        this.activeComponent = tab.component;
      },
    },
  };
</script>

<template>
  <v-dialog
    v-if="showDialog"
    v-model="showDialog"
    :max-width="393"
    :content-class="contentClass"
    @click:outside="closeDialog"
    @keydown.esc="closeDialog"
  >
    <div class="position-relative">
      <div class="tab-buttons">
        <div
          v-for="tab in tabs"
          :key="tab.value"
          :aria-label="`Open ${tab.text} tab`"
          :class="{ 'tab-button--active': tab.value === activeTab }"
          class="tab-button"
          @click="onTabClick(tab)"
        >
          <span>
            {{ tab.text }}
          </span>
        </div>
      </div>
      <div class="tab-content">
        <component :is="activeComponent" @payment-method-change="activePaymentMethod = $event" />
      </div>
    </div>
  </v-dialog>
</template>

<style lang="scss" scoped>
  .tab-buttons {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .tab-button {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-basis: 100%;
    cursor: pointer;

    span {
      color: #fff;
      opacity: 0.5;
      text-align: center;
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      letter-spacing: 0.36px;
      padding-top: 16px;
      padding-bottom: 16px;
    }

    &--active {
      cursor: default;
      box-shadow: 0 2px 0 0 #642198;

      span {
        opacity: 1;
      }
    }

    &:not(.tab-button--active):hover span {
      opacity: 0.75;
    }
  }

  .tab-content {
    padding: 16px 22px 24px 22px;
  }
</style>

<style lang="scss">
  .cashier-popup {
    width: 393px;
    border-radius: 10px;
    background: #350f53;
    min-height: 444px;

    &.cashier-popup--purchase.cashier-popup--crypto {
      min-height: 554px;
    }

    @media screen and (max-height: 600px) and (orientation: landscape) {
      min-height: auto !important;
    }
  }
</style>
